import { createContext } from "react";
import type { CalendarContextType } from "./types";

export const CalendarContext = createContext<CalendarContextType | undefined>(
  undefined,
);
